module.exports = __webpack_public_path__ + "img/business_slide1.d3dfa244.png";